import { Injectable } from "@angular/core";
import { PreloadAllModules, PreloadingStrategy } from "@angular/router";
import { Observable, of } from "rxjs";
import { AppRoute } from "../models/app-route.model";

/** Preload if data.disablePreload is not true */
@Injectable({
  providedIn: "root",
})
export class PreloadUnlessSpecified extends PreloadAllModules implements PreloadingStrategy {
  /** Preload if data.disablePreload is not true */
  override preload(route: AppRoute, fn: () => Observable<unknown>): Observable<unknown> {
    /*
    As of Angular Version 17, There are problems combining lazy-loaded components with
    route preload on last child elements (if route.navigate is used before preloading is finished)

    Investigate this further later, will most likely only become a problem if the PWA feature goes through
    */
    // if (route.loadComponent && !route.loadChildren && !route.children) {
    //   return of(null);
    // }

    if (route.data?.disablePreload) {
      return of(null);
    }

    return super.preload(route, fn);
  }
}
